import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore, Store } from 'redux';
import logger from 'redux-logger';
import promise from 'redux-promise-middleware';
import { thunk } from 'redux-thunk'; // use the default import
import reducers from './reducers/index';

const middleware =
	process.env.NODE_ENV === 'production'
		? composeWithDevTools(applyMiddleware(promise, thunk))
		: composeWithDevTools(applyMiddleware(promise, thunk, logger));

export const initStore = (initialState?: any): Store => createStore(reducers, initialState, middleware);

const store = createStore(reducers, middleware);
export type RootState = ReturnType<typeof store.getState>;

export default store;
